export function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



//////////////////
// WEBPACK FOOTER
// ./modules/socketapi/~/socket.io-client/build/esm/on.js
// module id = 420
// module chunks = 0